import type React from 'react';
import type { ReactNode } from 'react';

import { BusinessUnitsProvider } from './BusinessUnitsContext';
import { FeedbackProvider } from './FeedbackContext';
import { SidebarProvider } from './SidebarContext';

interface AppProvidersProps {
  children: ReactNode;
}

const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <BusinessUnitsProvider>
      <SidebarProvider>
        <FeedbackProvider>{children}</FeedbackProvider>
      </SidebarProvider>
    </BusinessUnitsProvider>
  );
};

export default AppProviders;
